import styled from 'styled-components';
import { View } from '@acin/ui-core';

// This named style should be the wrapper for the component i.e. the module
export const MainNav = styled(View)``;

export const MainNavTabs = styled(View)``;
